import React from 'react';
import { Button, Space, Popconfirm } from 'antd';
import type { Mode } from '../hooks/usePWH204Mode';

interface ActionBarProps {
  mode: Mode;
  hasRecord: boolean;
  hasPrev: boolean;
  hasNext: boolean;
  saving: boolean;
  canEdit: boolean;
  canDelete: boolean;
  canAdd: boolean;
  onFirst: () => void;
  onPrev: () => void;
  onNext: () => void;
  onLast: () => void;
  onAdd: () => void;
  onEdit: () => void;
  onSave: () => void;
  onCancel: () => void;
  onDelete: () => void;
}

const ActionBar: React.FC<ActionBarProps> = ({
  mode, hasRecord, hasPrev, hasNext, saving,
  canEdit, canDelete, canAdd,
  onFirst, onPrev, onNext, onLast,
  onAdd, onEdit, onSave, onCancel, onDelete,
}) => {
  const isEditing = mode === 'add' || mode === 'edit';

  return (
    <div className="pwh204-action-bar">
      <Space wrap>
        {/* Navigation buttons (view mode) */}
        {!isEditing && (
          <>
            <Button onClick={onFirst} disabled={!hasPrev}>|◄</Button>
            <Button onClick={onPrev} disabled={!hasPrev}>◄</Button>
            <Button onClick={onNext} disabled={!hasNext}>►</Button>
            <Button onClick={onLast} disabled={!hasNext}>►|</Button>
          </>
        )}

        {/* Action buttons */}
        {!isEditing ? (
          <>
            {canAdd && <Button type="primary" onClick={onAdd}>新增</Button>}
            {canEdit && hasRecord && <Button onClick={onEdit}>修改</Button>}
            {canDelete && hasRecord && (
              <Popconfirm
                title="確認刪除此折讓單？"
                onConfirm={onDelete}
                okText="確認"
                cancelText="取消"
              >
                <Button danger>刪除</Button>
              </Popconfirm>
            )}
          </>
        ) : (
          <>
            <Button type="primary" onClick={onSave} loading={saving}>存檔</Button>
            <Button onClick={onCancel} disabled={saving}>還原</Button>
          </>
        )}
      </Space>
    </div>
  );
};

export default ActionBar;
